import { useTranslation } from "react-i18next";

export const LoginHeader = () => {
  const { t } = useTranslation(["auth"]);

  return (
    <header className="px-6 pt-7 pb-5">
      <h1 className="login-title">{t("loginToAccount", { ns: "auth" })}</h1>
      <p className="login-subtitle mt-2">
        {t("enterCredentials", { ns: "auth", defaultValue: "Enter your credentials to access your account" })}
      </p>
    </header>
  );
};
